import React from 'react';
import { Traveler } from '@marageti/z4-sdk/lib/people';
import { SWRResponse } from 'swr';
import { CountryCodeMap } from '@marageti/z4-sdk/lib/standards';
import UserProfile from './UserProfile/UserProfile';
import UserProfileSkeleton from './UserProfile/UserProfileSkeleton';
import UserProfileError from './UserProfile/UserProfileError';

type UserProfileViewProps = {
  countryCodes: SWRResponse<CountryCodeMap, any, any>
  traveler: SWRResponse<Traveler, any, any>
  contextMenuProps: Parameters<typeof UserProfile>[0]['contextMenuProps']
};

const UserProfileView = ({
  countryCodes,
  traveler,
  contextMenuProps,
}: UserProfileViewProps) => {
  if (traveler.isLoading || countryCodes.isLoading) {
    return <UserProfileSkeleton />;
  }

  if (traveler.error || countryCodes.error) {
    return <UserProfileError error={traveler.error || countryCodes.error} />;
  }

  if (traveler.data && countryCodes.data) {
    return (
      <UserProfile
        countryCodes={countryCodes.data}
        traveler={traveler.data}
        contextMenuProps={contextMenuProps}
      />
    );
  }

  return null;
};

export default UserProfileView;
